import React, { memo } from "react";
import { Button, Box, Typography } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useNavigate } from "react-router-dom";

interface QuickCreateCTAProps {
  buttonText?: string;
  redirectTo?: string;
}

const QuickCreateCTA: React.FC<QuickCreateCTAProps> = ({
  buttonText = "Create New TaaS Card",
  redirectTo = "/create-card",
}) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        p: 3,
        border: "1px dashed#D1D5DB",
        borderRadius: 3,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        bgcolor: "#F9FAFB",
        flexWrap: "wrap",
        gap: 2,
      }}
    >
      <Box>
        <Typography variant="h6" fontWeight={600} mb={0.5}>
          Ready to offer more?
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Add a new TaaS card to expand your services.
        </Typography>
      </Box>

      <Button
        variant="contained"
        startIcon={<AddCircleOutlineIcon />}
        onClick={() => navigate(redirectTo)}
        sx={{
          borderRadius: 2,
          textTransform: "none",
          fontWeight: 600,
          px: 3,
          py: 1.2,
          background: "linear-gradient(to right, #6366F1, #9F03FF)",
          color: "#fff",
          "&:hover": {
            boxShadow: "0 4px 14px rgba(99,102,241,0.3)",
            background: "linear-gradient(to right, #4F46E5, #8B5CF6)",
          },
        }}
      >
        {buttonText}
      </Button>
    </Box>
  );
};

export default memo(QuickCreateCTA);
